<script setup>
import { computed } from 'vue';
import PortalThreadAvatar from './PortalThreadAvatar.vue';

const props = defineProps({
  people: { type: Array, default: () => [] },
  size: { type: Number, default: 24 },
  max: { type: Number, default: 3 },
});

const visiblePeople = computed(() => props.people.slice(0, props.max));
const remainingCount = computed(() =>
  Math.max(props.people.length - visiblePeople.value.length, 0)
);
const peopleLabel = computed(() =>
  props.people.map(person => person.name || person.email).join(', ')
);
</script>

<template>
  <div
    v-if="people.length"
    v-tooltip.top="{ content: peopleLabel, delay: { show: 500, hide: 0 } }"
    class="flex items-center -space-x-2 rtl:space-x-reverse flex-shrink-0"
    :aria-label="peopleLabel"
  >
    <PortalThreadAvatar
      v-for="person in visiblePeople"
      :key="person.email"
      :person="person"
      :size="size"
    />
    <span
      v-if="remainingCount"
      class="relative inline-flex items-center justify-center rounded-full bg-n-slate-3 text-n-slate-11 text-xxs font-medium ring-2 ring-n-solid-1"
      :style="{ width: `${size}px`, height: `${size}px` }"
    >
      +{{ remainingCount }}
    </span>
  </div>
</template>
